import { Outlet } from 'react-router-dom';

const MessageThreadLayout = () => {
  return <Outlet />;
};

export default MessageThreadLayout;
